import { Schema as S } from "effect";

import { defineApi, staticApis } from "../client";
import {
	DailyBreakdown,
	LatestUsage,
	LedgerBalance,
	LedgerSession,
	LedgerUsage,
	RateCardHistory,
	RateCardVersion,
	SpendingSummary,
} from "../schemas/ledger";

export const {
	getLedgerBalance,
	getLatestUsage,
	getSpendingSummary,
	getDailyBreakdown,
	getRateCard,
	getRateCardHistory,
} = staticApis({
	getLedgerBalance: ["GET", "/ledger/balance", LedgerBalance],
	getLatestUsage: ["GET", "/ledger/latest-usage", LatestUsage],
	getSpendingSummary: ["GET", "/ledger/spending-summary", SpendingSummary],
	getDailyBreakdown: ["GET", "/ledger/daily-breakdown", DailyBreakdown],
	getRateCard: ["GET", "/ledger/rate-card", RateCardVersion],
	getRateCardHistory: ["GET", "/ledger/rate-card/history", RateCardHistory],
});

export const getLedgerUsage = defineApi("GetLedgerUsage", {
	args: { limit: S.Number, offset: S.Number },
	response: LedgerUsage,
	request: ({ limit, offset }) => ({
		method: "GET",
		path: "/ledger/usage",
		query: { limit, offset },
	}),
});

export const createLedgerTopupSession = defineApi("CreateLedgerTopupSession", {
	args: {
		accountId: S.String,
		amountCents: S.Number,
		successUrl: S.optionalKey(S.String),
		cancelUrl: S.optionalKey(S.String),
	},
	response: LedgerSession,
	request: (payload) => ({
		method: "POST",
		path: "/ledger/topup",
		body: payload,
	}),
});

export const createLedgerSetupSession = defineApi("CreateLedgerSetupSession", {
	args: { accountId: S.String, returnUrl: S.optionalKey(S.String) },
	response: LedgerSession,
	request: (payload) => ({
		method: "POST",
		path: "/ledger/setup",
		body: payload,
	}),
});

export const createLedgerPortalSession = defineApi(
	"CreateLedgerPortalSession",
	{
		args: { accountId: S.String, returnUrl: S.optionalKey(S.String) },
		response: LedgerSession,
		request: (payload) => ({
			method: "POST",
			path: "/ledger/portal",
			body: payload,
		}),
	},
);
